<script setup>
const { countryBannerVisible } = useSharedState()
</script>

<template>
    <div class="layout layout-default">
        <PartialsCountrySelector />
        <PartialsAgeGate />
        <div class="font-sans antialiased">
            <PartialsNavMobile />
            <PartialsNavDesktop />
            <div
                class="page z-12 -mb-12 mt-[var(--geloso-offset-top)] min-h-screen transition duration-650"
                :class="{
                    'translate-y-32 pb-32 xl:translate-y-24 xl:pb-24': countryBannerVisible,
                }"
            >
                <slot />
            </div>
            <PartialsFooter />
        </div>
    </div>
</template>
